import type { ContactAddress } from 'src/api/generated';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import MenuDropdown from 'src/modules/shared/components/molecules/dropdowns/menu-dropdown';
import type { DropdownItem } from 'src/modules/shared/components/molecules/dropdowns/dropdown';
import type { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import { PiDotsThreeVertical } from 'react-icons/pi';
import { ContactCallButton } from '../../molecules/buttons/contact-call-button';

export const ConversationHeaderActionButtons = ({
  addresses,
  conversationName,
  handleCall,
  handlerSize,
  isLoading,
  items,
  t,
}: {
  addresses?: ContactAddress[];
  conversationName: string;
  handleCall: (phoneNumber: string) => void;
  handlerSize: 'sm' | 'md';
  isLoading: boolean;
  items: DropdownItem[];
  t: ReturnType<typeof useI18n>['t'];
}) => (
  <div className="flex min-h-10 items-center gap-2">
    <ContactCallButton
      addresses={addresses}
      onCall={handleCall}
      isLoading={isLoading}
      size={handlerSize}
      split={false}
    />

    <MenuDropdown
      items={items}
      mobileTitle={conversationName}
      handlerComponent={
        <Button
          variant="neutral"
          appearance="ghost"
          size={handlerSize}
          isIconOnly
          aria-label={t('communications.conversationHeader.moreActions')}
        >
          <PiDotsThreeVertical className="h-5 w-5" />
        </Button>
      }
    />
  </div>
);
